// Package imports:
import React, { useEffect, useMemo, useState } from 'react';
// Service imports:
import { GET_KELDAN_API_URL } from '../../../services/config';
import { ErrorMessages } from '../../../services/errorMessages';
// Type imports:
import { Fetched } from '../../../types/Types';
import { IKeldanApiResponse,  } from '../../../types/KeldanTypes';
import { ICompanyViewModel } from '../../../types/CompanyTypes';

interface ICompanyAwards {
    excellent2017: boolean
    excellent2018: boolean
    excellent2019: boolean
    excellent2020: boolean
    excellent2021: boolean
    excellent2022: boolean
}
const url = "https://cdn.livemarketdata.com/Images/Excellent/"
const CompanyAwards: React.FC<ICompanyViewModel> = ({
    id
}) => {
    const [data, setData] = useState<Fetched<ICompanyAwards>>(null);

    const fetchCompanyAwardsData = async () => {
        try {
            const url = `${GET_KELDAN_API_URL()}/Company/GetCompanyAwards/${id}`;
            const headers = {
                'Content-Type': 'application/json; charset=utf-8'
            };
            
            const response = await fetch(url, {
                method: 'GET',
                headers
            });
            if (response.ok) {
                const responseBody: IKeldanApiResponse<ICompanyAwards> = await response.json();
                if (responseBody.success) {
                    if(responseBody.result) setData(responseBody.result);
                } else {
                    const { message } = responseBody;
                    if (message) {
                        setData(new Error(message));
                    } else {
                        setData(new Error(ErrorMessages.ErrorInRequest));
                    }
                }
            } else {
                setData(new Error(ErrorMessages.RequestFailed));
            }
        } catch (e) {
            setData(new Error(ErrorMessages.OtherShort));
        }
    }
   
    useEffect(() => {
        fetchCompanyAwardsData();
    }, [])

    const years = useMemo(() => {
        return data instanceof Error || data === null
            ? null
            : data.excellent2022
                ? data.excellent2021
                    ? data.excellent2020
                        ? data.excellent2019
                            ? data.excellent2018
                                ? data.excellent2017
                                    ? '2017-2022'
                                    : '2018-2022'
                                : '2019-2022'
                            : '2020-2022'
                        : '2021-2022'
                    : '2022'
                : data.excellent2021
                    ? data.excellent2020
                        ? data.excellent2019
                            ? data.excellent2018
                                ? data.excellent2017
                                    ? '2017-2021'
                                    : '2018-2021'
                                : '2019-2021'
                            : '2020-2021'
                        : '2021'
                    : data.excellent2020
                        ? data.excellent2019
                            ? data.excellent2018
                                ? data.excellent2017
                                    ? '2017-2020'
                                    : '2018-2020'
                                : '2019-2020'
                            : '2020'
                        : data.excellent2019
                            ? data.excellent2018
                                ? data.excellent2017
                                    ? '2017-2019'
                                    : '2018-2019'
                                : '2019'
                            : data.excellent2018
                                ? data.excellent2017
                                    ? '2017-2018'
                                    : '2018'
                                : data.excellent2017
                                    ? '2017'
                                    : null;
    }, [data]);

    return <div className="KCL_company-awards">
        {data === null || years === null
            ? null
            : <a href='/Lists/Excellent'>
                <img
                    src={`${url}fyrirmyndar${years}.svg`}
                    alt={`Fyrirmyndarfyrirtæki í rekstri ${years}`}
                    width="800"
                    height="469"
                />
            </a>
        }
    </div>;
}

export default CompanyAwards;